import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import axios from 'axios';

const LandingPage = () => {
  const [teachers, setTeachers] = useState([]);

  useEffect(() => {
    fetchTeachers();
  }, []);

  const fetchTeachers = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/users/teachers`);
      setTeachers(response.data);
    } catch (error) {
      console.error('Error fetching teachers:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative overflow-hidden">
        {/* Decorative Elements */}
        <div className="absolute top-0 left-0 w-64 h-64 bg-gradient-to-br from-blue-200 to-blue-100 rounded-full filter blur-3xl opacity-30 -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-to-br from-purple-200 to-purple-100 rounded-full filter blur-3xl opacity-30 translate-x-1/2 translate-y-1/2"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 relative">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-block mb-4 animate-bounce">
                <span className="px-4 py-2 bg-gradient-to-r from-blue-100 to-purple-100 text-blue-700 text-sm font-semibold rounded-full border-2 border-blue-300">
                  🎓 Trusted by 10,000+ students worldwide
                </span>
              </div>
              
              <h1 className="text-6xl font-extrabold mb-4 leading-tight">
                <span className="text-gray-900">Transform Your Future with</span>
                <br />
                <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">Expert-Led Learning</span>
              </h1>
              
              <p className="text-xl text-gray-700 mb-8 leading-relaxed font-medium">
                Master life skills, communication, and languages through personalized live classes. 
                <span className="text-blue-600 font-bold"> Your success journey starts here! 🚀</span>
              </p>
              
              <div className="flex gap-4">
                <Link 
                  to="/register" 
                  className="px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl font-bold hover:from-blue-700 hover:to-purple-700 transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                >
                  🎯 Start Free Trial
                </Link>
                
                <Link 
                  to="/login" 
                  className="px-8 py-4 bg-white text-gray-800 border-2 border-blue-300 rounded-xl font-bold hover:bg-blue-50 transition-all shadow-md"
                >
                  Sign In
                </Link>
              </div>

              {/* Trust Indicators */}
              <div className="flex items-center gap-8 mt-10 pt-8 border-t-2 border-blue-200">
                <div className="text-center">
                  <div className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">10K+</div>
                  <div className="text-sm text-gray-600 font-medium">Active Students</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">50+</div>
                  <div className="text-sm text-gray-600 font-medium">Expert Teachers</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">4.9⭐</div>
                  <div className="text-sm text-gray-600 font-medium">Top Rated</div>
                </div>
              </div>
            </div>

            {/* Hero Illustration */}
            <div className="relative">
              <div className="bg-gradient-to-br from-blue-100 via-white to-purple-100 rounded-3xl p-8 shadow-2xl border-4 border-blue-200">
                <div className="space-y-4">
                  <div className="bg-white rounded-xl p-5 shadow-lg border-l-4 border-blue-500 transform hover:scale-105 transition-transform">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center shadow-md">
                        <span className="text-white font-bold text-lg">👨‍🏫</span>
                      </div>
                      <div>
                        <div className="font-bold text-gray-900">Sarah Johnson</div>
                        <div className="text-xs text-blue-600 font-semibold">⭐ Life Coach Expert</div>
                      </div>
                    </div>
                    <div className="text-sm text-gray-700 font-medium">📚 Next: Communication Skills</div>
                    <div className="text-xs text-purple-600 mt-1 font-semibold">🕐 Today at 3:00 PM</div>
                  </div>
                  
                  <div className="bg-white rounded-xl p-5 shadow-lg border-l-4 border-purple-500">
                    <div className="flex justify-between items-center mb-3">
                      <span className="text-sm font-bold text-gray-900">Your Progress 🚀</span>
                      <span className="text-sm text-purple-600 font-bold">75%</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-3 shadow-inner">
                      <div className="bg-gradient-to-r from-blue-500 to-purple-500 h-3 rounded-full shadow-md" style={{width: '75%'}}></div>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-3">
                    <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-4 shadow-lg text-center border-2 border-blue-200 transform hover:scale-105 transition-transform">
                      <div className="text-2xl font-bold text-blue-600">24 ✅</div>
                      <div className="text-xs text-gray-700 font-semibold">Classes Done</div>
                    </div>
                    <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-4 shadow-lg text-center border-2 border-purple-200 transform hover:scale-105 transition-transform">
                      <div className="text-2xl font-bold text-purple-600">8 🏆</div>
                      <div className="text-xs text-gray-700 font-semibold">Certificates</div>
                    </div>
                  </div>
                  
                  {/* Decorative Element */}
                  <div className="text-center text-4xl animate-pulse">
                    📚 ✨ 🎓
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Programs Section */}
      <section className="py-16 bg-gradient-to-r from-blue-50 to-purple-50 relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-extrabold mb-3">
              <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                Programs for Every Age
              </span>
            </h2>
            <p className="text-gray-700 text-lg font-medium">Your personalized path to success 🌟</p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            {[
              {
                age: '10-17 years',
                title: '🌱 Young Achievers Program',
                description: 'Build confidence and essential life skills for success',
                features: ['Personal Development 🎯', 'Communication Skills 💬', 'Language Basics 📚'],
                gradient: 'from-blue-500 to-cyan-500',
                bgGradient: 'from-blue-50 to-cyan-50',
                emoji: '🎓'
              },
              {
                age: '17-22 years',
                title: '🚀 Career Ready Program',
                description: 'Advanced skills for professional success and leadership',
                features: ['Leadership Training 👑', 'Public Speaking 🎤', 'Business Communication 💼'],
                gradient: 'from-purple-500 to-pink-500',
                bgGradient: 'from-purple-50 to-pink-50',
                emoji: '💼'
              }
            ].map((program, index) => (
              <div 
                key={index}
                className={`bg-gradient-to-br ${program.bgGradient} rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all border-4 border-white transform hover:-translate-y-2`}
              >
                <div className="flex items-center justify-between mb-4">
                  <div className={`inline-block px-4 py-2 bg-gradient-to-r ${program.gradient} text-white text-sm font-bold rounded-full shadow-md`}>
                    {program.age}
                  </div>
                  <div className="text-4xl">{program.emoji}</div>
                </div>
                
                <h3 className="text-2xl font-extrabold text-gray-900 mb-3">{program.title}</h3>
                <p className="text-gray-700 mb-6 font-medium">{program.description}</p>
                
                <ul className="space-y-3">
                  {program.features.map((feature, i) => (
                    <li key={i} className="flex items-center text-gray-800 font-medium">
                      <svg className="w-6 h-6 text-green-600 mr-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                      </svg>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Courses Section */}
      <section className="py-16 bg-white relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-extrabold mb-3">
              <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                🌟 Popular Courses
              </span>
            </h2>
            <p className="text-gray-700 text-lg font-medium">Skills that transform careers and lives ✨</p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            {[
              { 
                icon: '🎯', 
                title: 'Life Coaching', 
                desc: 'Build confidence, set goals, and unlock your potential',
                students: '2,500+',
                rating: '4.9',
                gradient: 'from-blue-400 to-cyan-400',
                bgColor: 'bg-blue-50'
              },
              { 
                icon: '💬', 
                title: 'Communication Skills', 
                desc: 'Master public speaking and interpersonal communication',
                students: '3,200+',
                rating: '4.8',
                gradient: 'from-purple-400 to-pink-400',
                bgColor: 'bg-purple-50'
              },
              { 
                icon: '🌍', 
                title: 'Language Learning', 
                desc: 'Learn new languages through interactive live sessions',
                students: '1,800+',
                rating: '4.9',
                gradient: 'from-green-400 to-teal-400',
                bgColor: 'bg-green-50'
              }
            ].map((course, index) => (
              <div 
                key={index}
                className={`${course.bgColor} rounded-2xl border-4 border-white hover:border-blue-200 hover:shadow-2xl transition-all duration-300 overflow-hidden group transform hover:-translate-y-2`}
              >
                <div className={`h-2 bg-gradient-to-r ${course.gradient}`}></div>
                <div className="p-6">
                  <div className="text-5xl mb-4 transform group-hover:scale-110 transition-transform">{course.icon}</div>
                  <h3 className="text-2xl font-extrabold text-gray-900 mb-3">{course.title}</h3>
                  <p className="text-gray-700 text-sm mb-4 leading-relaxed font-medium">{course.desc}</p>
                  
                  <div className="flex items-center justify-between pt-4 border-t-2 border-gray-200">
                    <div className="flex items-center text-sm text-gray-700 font-semibold">
                      <svg className="w-5 h-5 mr-1 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"/>
                      </svg>
                      {course.students}
                    </div>
                    <div className="flex items-center text-sm font-bold text-gray-900">
                      <svg className="w-5 h-5 text-yellow-500 mr-1" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                      </svg>
                      {course.rating}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Teachers Section */}
      {teachers.length > 0 && (
        <section className="py-16 bg-gradient-to-br from-blue-50 to-purple-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-extrabold mb-3">
                <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                  👨‍🏫 Meet Our Expert Teachers
                </span>
              </h2>
              <p className="text-gray-700 text-lg font-medium">Learn from the finest educators 🎓</p>
            </div>
            
            <div className="grid md:grid-cols-3 gap-8">
              {teachers.map((teacher) => (
                <div 
                  key={teacher._id}
                  className="bg-white rounded-2xl p-6 shadow-xl hover:shadow-2xl transition-all border-4 border-blue-100 hover:border-blue-300 transform hover:-translate-y-2"
                >
                  <div className="flex items-start gap-4 mb-4">
                    <div className="w-20 h-20 bg-gradient-to-br from-blue-500 via-purple-500 to-pink-500 rounded-full flex items-center justify-center text-3xl font-bold text-white shadow-lg flex-shrink-0 border-4 border-white">
                      {teacher.name.charAt(0)}
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-extrabold text-gray-900">{teacher.name}</h3>
                      <p className="text-sm text-blue-600 font-semibold">⭐ Expert Instructor</p>
                      <p className="text-sm text-gray-600 mt-1">{teacher.bio || 'Transforming lives through education'}</p>
                    </div>
                  </div>
                  
                  <div className="flex items-center gap-4 pt-4 border-t-2 border-blue-100">
                    <div className="flex items-center text-sm text-gray-700 font-semibold">
                      <svg className="w-5 h-5 text-yellow-500 mr-1" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                      </svg>
                      4.9
                    </div>
                    <div className="text-sm text-gray-700 font-semibold">500+ students</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Footer */}
      <footer className="bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 border-t-4 border-blue-500 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-white font-bold text-lg">🎓 CoachingHub - Empowering Education</p>
          <p className="mt-2 text-blue-100 font-medium">Contact: info@coachinghub.com | +1 234 567 8900</p>
          <p className="mt-2 text-blue-200 text-sm">© 2024 CoachingHub. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
